/**
 * !!!! AFTER ANY CHANGE DONE HERE, APPLY TO SECURITY RULES & COPY TO FUNCTIONS' CONFIG !!!!
 */

export const Roles = {
  SUPERADMIN: 0, // highest level of admin - no company assigned, can do everything everywhere
  COMPANY: {
    ADMIN: 10, // admin in a Company
    USER: 20 // all the other users/roles in Company (manager, agent, client, salesperson)
  },
  PROJECT: {
    MANAGER: 10, // admin in a project
    AGENT: 20, // agent in a project
    CLIENT: 30, // client (only view permissions) in a project
    SALESPERSON: 40 // sales person in a project
  }
}

// static config variables
export const Config = {}



// WEBPACK FOOTER //
// ./src/config.js